import DatePicker from "react-datepicker"
import { forwardRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../css/element/DateSelector.css";
import { ko } from 'date-fns/esm/locale'

let getDateString = (date) => {
    let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
    return date.getFullYear() + '-' + (month) + '-' + day;
}
/**
 * @param {Date|string} date
 * @returns {Date}
 */
let getEndDate = (date) => {
    let endDate = new Date(date);
    endDate.setDate(endDate.getDate() + 6);
    return endDate
}

const CustomInput = forwardRef(({ value, onClick }, ref) => {
    let select = new Date(value)
    let day = select.getDay()
    day = day === 0 ? 7 : day
    let start = new Date(select)
    start.setDate(select.getDate() - day + 1)

    return (
        <div className="date-selector" ref={ref}>
            <p className="date-selector-text">
                {getDateString(start)} ~ {getDateString(getEndDate(start))}
            </p>
            <div className="calendar-icon-container" onClick={onClick}>
            </div>
        </div>
    )
});
let TableDateSelector = (props) => {
    /**
     *
     * @param {Date} date
     * @returns {boolean}
     */
    let dateFilter = (date) => {
        let today = new Date();
        let oneMonthAfter = new Date();
        oneMonthAfter.setMonth(today.getMonth() + 1)
        return (props.isAdmin || getDateString(date) <= getDateString(oneMonthAfter));
    }

    let onClickDate = (date) => {
        let day = date.getDay()
        day = day === 0 ? 7 : day
        let start = new Date(date)
        start.setDate(date.getDate() - day + 1)

        props.onChangeDate(start, getEndDate(start), date)
    }


    return (<DatePicker dateFormat="yyyy-MM-dd" selected={props.selectedDate}
        locale={ko}
        onChange={onClickDate}
        customInput={<CustomInput />}
        filterDate={dateFilter}
    ></DatePicker>);
}
export default TableDateSelector;